import styled from '@emotion/styled'

const BackgroundRectangle = styled.div`
  width: 70vw;
  height: 300px;
  background-color: ${({ theme }) => theme.secondary_850};
`

export default BackgroundRectangle
